// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--3JGQe","FaArrowLeft":"index-module--FaArrowLeft--3-fxo","FaArrowRight":"index-module--FaArrowRight--1fqAL"};